module.exports = __webpack_public_path__ + "img/swedish_pine.f6ab0938.jpg";